export default function ({ store }) {
  return store.state.user.lang || "en"
}
